var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserLimits(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "group"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 6.00065,
    cy: 5.99967,
    r: 1.66667,
    stroke: "#656461",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.3337 7.34693C11.3337 9.8634 8.23709 11.7328 6.76041 12.4833C6.28395 12.7269 5.71963 12.7274 5.24276 12.4846C3.76707 11.7348 0.666992 9.86087 0.666992 7.34693V3.71259C0.671895 3.37202 0.929811 3.0885 1.26839 3.05147C2.683 2.94397 4.03923 2.44242 5.18339 1.60363C5.66824 1.2428 6.33238 1.2428 6.81723 1.60363C7.9614 2.44242 9.31762 2.94397 10.7322 3.05147C11.0708 3.08848 11.3288 3.37201 11.3337 3.71259V7.34693Z",
    stroke: "#656461",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.26711 10.8673L8.96063 10.2543C8.67831 9.68969 8.1012 9.33301 7.46991 9.33301H4.53001C3.89872 9.33301 3.32161 9.68969 3.03929 10.2543L2.73438 10.8642",
    stroke: "#656461",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserLimits);
export default __webpack_public_path__ + "static/media/user-limits.1519f85af445b9bfded46825c33ee9c5.svg";
export { ForwardRef as ReactComponent };